module.exports = "query ($tasks: [String!]) {\n    taskMultipleGet(taskIds: $tasks) {\n        uuid\n        status\n        result\n        error\n    }\n}\n"